<template>
  <div v-if="itemsRendered">
    <a
      v-on:click.prevent="trackAdLink(ad)"
      class="btn btn-cta btn-sm pull-right open-account-btn"
      rel="nofollow"
    >Open an Account</a>
    {{bankName}}
    <div class="go-to-link">
      <a href="" v-on:click.prevent="trackAdLink(ad)">Go to Website</a>
    </div>
    <img class="tPixel" v-bind:src="$filters.formatTrackingFilter(ad.pixel)">
  </div>
</template>

<script lang="ts">
import Vue, { defineComponent, createApp } from "vue";
import apiClient from "../../services/apiClient";
import analytics from "../../services/analytics";
import { adClickMixin } from "../../mixins/adClickMixin";
import horizontalAds from "../horizontalAds/horizontalAds.vue";

export default defineComponent({
  name: "openAccount",
  mixins: [adClickMixin],
  props:
  {
    bankId: {
      default: 0
    },
    bankName: {
      default: ""
    },
    bankLink: {
      default: ""
    },
    hasReviews: {
      default: false
    }
  },
  data: function() {
    return {
      ad: {} as AdPlacement,
      itemsRendered: false
    };
  },
  mounted() {
    apiClient
      .getAdPlacementsInZone("da-bp-oa", this.bankId, false)
      .then(adsData => {
        if (!(adsData && adsData.length)) {
          return;
        }

        analytics.trackAdImpressions("da-bp-oa", adsData);  // must preceed adclick wraps
        this.ad = adsData[0];
      
        let encodedAd : string = btoa(JSON.stringify(this.ad));
        $("#bankLogo")
          .parent()
          .wrap(
            "<a href='' data-ad='" + encodedAd +
              "'  onclick='return logAdClickV2(this, event);'></a>"
          );

        $(".website").html(
          '<a href="" rel="nofollow" data-ad=\'' + encodedAd +
            "' onclick='return logAdClickV2(this, event);'>" +
            this.getDisplayWebsite(this.bankLink) +
            "</a>"
        );        

        $("#advertiserSpan").html(", a DepositAccounts.com advertiser,");

        this.itemsRendered = true;   
        $('.deposit-insurance-note-overview-span').show();
      })
      .finally(() => {
        // We need to show horizontal Ads Only if openAccount ad is not there.
        if (!Object.keys(this.ad).length && this.hasReviews) {
          this.showHorizontalAds();
        }
        if (!Object.keys(this.ad).length) {
          $(".deposit-insurance-note-overview-top").show();
        }
      });
  },
  methods: {
    getDisplayWebsite(websiteAddress: string) {
      let link = document.createElement("a");
      link.href = websiteAddress;
      return link.hostname;
    },
    showHorizontalAds() {
      const app = createApp(horizontalAds);
      app.mount("#horizontalAdsHolder");
    }
  }
});
</script>
<style lang="scss" scoped>
.open-account-btn {
  margin-top: 4px;
}
.go-to-link {
  font-size: 13px;
  font-weight: normal;
  font-family: Arial;
}
.tPixel {
  display: none;
}
</style>
